import { render, staticRenderFns } from "./CatchAllModal.vue?vue&type=template&id=e95bffd8&"
import script from "./CatchAllModal.vue?vue&type=script&lang=js&"
export * from "./CatchAllModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e95bffd8')) {
      api.createRecord('e95bffd8', component.options)
    } else {
      api.reload('e95bffd8', component.options)
    }
    module.hot.accept("./CatchAllModal.vue?vue&type=template&id=e95bffd8&", function () {
      api.rerender('e95bffd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/CatchAllModal.vue"
export default component.exports